import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodOxygenLogPage = lazy(() => import("./BloodOxygenLogPage.tsx"));

const BloodOxygenLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodOxygenLogPage />
    </Suspense>
  );
};

export default BloodOxygenLogPageLazy;
